let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Lclck")).then(() => parcelRequire('k8wr3'));